<template>
  <div id="robot">
    <div class="now_version">
      当前版本: {{
        info.now_version
      }}<span class="export" @click="export2CSV">导出数据到文档</span>
    </div>

    <section>
      <fieldset class="field-title">
        <legend class="field-text">入款笔数: {{ info.in_num }}</legend>
        <ul class="detail-list">
          <li>
            <span>组数</span>
            <span>时间</span>
            <span>金额</span>
            <span>用户</span>
          </li>
          <li v-for="(line, index) in info.in_num_detail" :key="'in-' + index">
            <span>{{ line.group_name }}</span>
            <span>{{ formatTime(line.create_at) }}</span>
            <span>{{ line.money }}</span>
            <span>{{ line.user_name }}</span>
          </li>
        </ul>
      </fieldset>
    </section>

    <section>
      <fieldset class="field-title">
        <legend class="field-text">出款笔数: {{ info.out_num }}</legend>
        <ul class="detail-list">
          <li>
            <span>组数</span>
            <span>时间</span>
            <span>金额</span>
            <span>用户</span>
          </li>
          <li v-for="(line, index) in info.out_num_detail" :key="'out-' + index">
            <span>{{ line.group_name }}</span>
            <span>{{ formatTime(line.create_at) }}</span>
            <span>{{ line.money }}</span>
            <span>{{ line.user_name }}</span>
          </li>
        </ul>
      </fieldset>
    </section>

    <section>
      <fieldset class="field-title">
        <legend class="field-text">下发笔数: {{ info.usd_num }}</legend>
        <ul class="detail-list">
          <li>
            <span></span>
            <span>时间</span>
            <span>金额</span>
            <span>用户</span>
          </li>
          <li v-for="(line, index) in info.usd_num_detail" :key="'usd-' + index">
            <span></span>
            <span>{{
                formatTime(line.create_at)
            }}</span>
            <span>{{ line.money }}</span>
            <span>{{ line.user_name }}</span>
          </li>
        </ul>
      </fieldset>
    </section>

    <section>
      <fieldset class="field-title">
        <legend class="field-text">分用户统计</legend>
        <table border="1" class="user-summary-table" style="width: 100%; text-align: center;">
          <thead>
            <tr>
              <th>入款总额</th>
              <th>出款总额</th>
              <th>用户</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(user, index) in info.shows" :key="'user-' + index">
              <td>{{ user.in_all_money_meta }}({{ user.in_balance_u }}u)</td>
              <td>{{ user.out_all_money_meta }}({{ user.out_balance_u_meta }}u)</td>
              <td>{{ user.user_name }}</td>
            </tr>
          </tbody>
        </table>
      </fieldset>
    </section>

    <section class="summary">
      <fieldset class="field-title">
        <legend class="field-text">总计</legend>
        <ul class="detail-list">
          <li>
            <span>入款总额:</span>
            <span>{{ info.in_all_money }}</span>
          </li>
          <li v-for="(line, index) in info.in_all_detail" :key="'in_all-' + index">
            <span>{{ line.group_name }}组总计</span>
            <span>{{ line.money }}</span>
          </li>
          <br />

          <li>
            <span>出款总额:</span>
            <span>{{ info.out_all_money }}</span>
          </li>
          <li v-for="(line, index) in info.out_all_money_detail" :key="'out_all-' + index">
            <span>{{ line.group_name }}组总计</span>
            <span>{{ line.money }}</span>
          </li>
          <br />

          <li>
            <span>下发总额:</span>
            <span>{{ info.usd_all_money }}</span>
          </li>
          <li>
            <span>下发总额U:</span>
            <span>{{ info.usd_all_money_u }}</span>
          </li>
          <br />

          <li>
            <span>入款费率:</span>
            <span>{{ info.in_rate }}</span>
          </li>
          <li>
            <span>出款费率:</span>
            <span>{{ info.out_rate }}</span>
          </li>
          <li>
            <span>usd汇率:</span>
            <span>{{ info.usd_rate }}</span>
          </li>
          <br />

          <li>
            <span>余额:</span>
            <span>{{ info.balance }}</span>
          </li>
        </ul>
      </fieldset>
    </section>
  </div>
</template>

<style lang="less">
#robot {
  text-align: left;

  .now_version {
    font-weight: 500;
  }

  section {
    margin-top: 20px;

    .field-title {
      margin: 10px 0 20px;
      border-width: 1px 0 0;

      legend {
        margin-left: 20px;
        padding: 0 10px;
        font-size: 20px;
        font-weight: 300;
      }
    }

    ul.detail-list {
      li {
        width: 100%;
        max-width: 720px;
        display: flex;
        flex-wrap: nowrap;

        span {
          display: inline-block;

          &:nth-child(1) {
            width: 15%;
          }

          &:nth-child(2) {
            width: 30%;
          }

          &:nth-child(3) {
            width: 40%;
          }

          &:nth-child(4) {
            width: 15%;
          }
        }
      }
    }

    &.summary {
      ul.detail-list {
        li {
          span {
            &:nth-child(1) {
              width: 30%;
            }

            &:nth-child(2) {
              width: 70%;
            }
          }
        }
      }
    }
  }

  span.export {

    &:active {
      color: blueviolet;
    }

    color: blue;
    float: right;
    text-decoration-line: none;
  }
}
</style>

<script>
import { getInfo } from "@/api/robot";
import saveTextAsFile from "@/utils/saveTextAsFile";

export default {
  name: "Robot",
  data() {
    return {
      info: {},
    };
  },
  async mounted() {
    const params = this.$route.query;
    const info = await getInfo(params);
    if (info.code === 0) {
      this.info = info.data;
    }
  },
  methods: {
    formatTime(timestamp) {
      if (!timestamp) return ''

      // 秒级时间戳修复
      const ts = String(timestamp).length === 10
        ? Number(timestamp) * 1000
        : Number(timestamp)

      const date = new Date(ts)

      const m = String(date.getMonth() + 1).padStart(2, '0')
      const d = String(date.getDate()).padStart(2, '0')
      const h = String(date.getHours()).padStart(2, '0')
      const i = String(date.getMinutes()).padStart(2, '0')
      const s = String(date.getSeconds()).padStart(2, '0')

      return `${m}-${d} ${h}:${i}:${s}`
    },
    convertData(data) {
      let arr = [];

      if (data.now_version) {
        arr.push(`当前版本:, ${data.now_version}`);
        arr.push(``);
      }


      arr.push(`入款笔数:, ${data.in_num || 0}`);
      if (data.in_num) {
        arr.push(`组数,时间,金额,用户`);
        data.in_num_detail.forEach((line) => {
          arr.push(
            `${line.group_name},${new Date(
              line.create_at
            ).toLocaleTimeString()},${line.money},${line.user_name}`
          );
        });
      }
      arr.push(``);

      arr.push(`出款笔数:, ${data.out_num || 0}`);
      if (data.out_num) {
        arr.push(`组数,时间,金额,用户`);
        data.out_num_detail.forEach((line) => {
          arr.push(
            `${line.group_name},${new Date(
              line.create_at
            ).toLocaleTimeString()},${line.money},${line.user_name}`
          );
        });
      }
      arr.push(``);

      arr.push(`下发笔数:, ${data.usd_num || 0}`);
      if (data.usd_num) {
        arr.push(`组数,时间,金额,用户`);
        data.usd_num_detail.forEach((line) => {
          arr.push(
            `${line.group_name},${new Date(
              line.create_at
            ).toLocaleTimeString()},${line.money},${line.user_name}`
          );
        });
      }
      arr.push(``);

      arr.push(`总计`)
      arr.push(`入款总额：,${data.in_all_money}`)
      data.in_all_detail && data.in_all_detail.forEach(line => {
        arr.push(`${line.group_name}组总计：,${line.money}`)
      })
      arr.push(``);

      arr.push(`出款总额：,${data.out_all_money}`)
      data.out_all_money_detail && data.out_all_money_detail.forEach(line => {
        arr.push(`${line.group_name}组总计：,${line.money}`)
      })
      arr.push(``);

      arr.push(`下发总额：,${data.usd_all_money}`)
      arr.push(``);

      arr.push(`入款汇率：,${data.in_rate}`)
      arr.push(`出款汇率：,${data.out_rate}`)
      arr.push(`usd汇率：,${data.usd_rate}`)
      arr.push(``);

      arr.push(`余额：,${data.balance}`)

      return arr;
    },
    export2CSV() {

      const fileName = `${this.info.now_version.replace(/ /g, '').replace(/:/g, '_')}_${this.$route.query.chat_id}.csv`
      saveTextAsFile(this.convertData(this.info).join('\r'), fileName)
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/Robot.vue